/* ===== くつひもメーター 紐の図（B マテリアル）=====
 * 単独ページとモーダルの全ステップの図をここで描く（Issue meta#28）。
 * - 紐はすべてダークブラウンの丸紐（撚りを線の重ねで描く）。お客様は今通している紐を測るので、
 *   商品ページから開いても商品の色・形・太さには合わせない（友哉くん 2026-10-08 決定）
 * - 交差は上を通る紐に影と余白を付けて上下を表す
 * - 穴は枠だけの円を紐の上に重ねる（金属ハトメ・黒塗りはしない）
 * - 紐の端は必ず穴の中心で終える（採寸の基準＝穴の中を通る紐）。交差の余白は穴の手前で止める
 * - 靴の裏側を通る紐は、同じ紐を薄く描く（透け）
 * - 描画順: 裏を通る紐(透け) → 先端 → 下の紐 → 交差の余白 → 上の紐(影) → 表の横バー → 穴の枠 → 強調
 * 公開: window.ShoelaceLaceArt（shoelace-calculator.js から呼ぶ。素の JS・ビルドなし）
 */
(function () {
  'use strict';

  var NS = 'http://www.w3.org/2000/svg';
  var C = {
    ink: '#262420', text: '#3E3B35', muted: '#96917F',
    line: '#E3DED2', lineStrong: '#CFC7B3', gold: '#9B831B',
    paper: '#FBFAF7', paperAlt: '#F5F3EE', hole: '#8C8473'
  };
  var FONT_JP = "'Noto Sans JP', sans-serif";
  var FONT_NUM = "Jost, 'Noto Sans JP', sans-serif";

  // 紐の色（ダークブラウン）: 地(base)・艶(hi)
  var LACE = { base: '#3B3128', hi: '#7A6C5A' };

  // ---------- SVG の基本 ----------
  var uid = 0;
  function el(tag, attrs, parent) {
    var e = document.createElementNS(NS, tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (attrs[k] !== null && attrs[k] !== undefined) e.setAttribute(k, String(attrs[k]));
    });
    if (parent) parent.appendChild(e);
    return e;
  }
  function r2(v) { return Math.round(v * 100) / 100; }
  function txt(parent, x, y, s, o) {
    o = o || {};
    var t = el('text', {
      x: r2(x), y: r2(y), 'text-anchor': o.anchor || 'middle',
      'font-family': o.num ? FONT_NUM : FONT_JP, 'font-size': o.size || 13,
      'font-weight': o.weight || null, fill: o.fill || C.text,
      'letter-spacing': o.ls || null
    }, parent);
    t.textContent = s;
    return t;
  }

  // 1 枚の図の描画状態（defs の ID は図ごとに一意）
  function makeCtx(viewBox, label, scale, bg) {
    var id = 'sla' + (++uid);
    var svg = el('svg', { viewBox: viewBox, xmlns: NS, role: 'img', 'aria-label': label });
    var defs = el('defs', null, svg);
    var ag = el('linearGradient', { id: id + 'ag', x1: 0, x2: 1, y1: 0, y2: 0 }, defs);
    [['0', '#6F6C66'], ['.35', '#ECEAE5'], ['.6', '#A3A098'], ['1', '#55524C']].forEach(function (st) {
      el('stop', { offset: st[0], 'stop-color': st[1] }, ag);
    });
    var f = el('filter', { id: id + 'lift', x: '-20%', y: '-20%', width: '140%', height: '140%' }, defs);
    el('feDropShadow', { dx: 0, dy: r2(1.2 * scale), stdDeviation: r2(1 * scale),
      'flood-color': C.ink, 'flood-opacity': 0.28 }, f);
    return {
      svg: svg, defs: defs, id: id, s: scale, bg: bg || C.paperAlt, pal: LACE
    };
  }

  function laceWidth(ctx) { return 4.4 * ctx.s; }

  function strokePath(g, d, color, w, cap, dash, op) {
    return el('path', {
      d: d, fill: 'none', stroke: color, 'stroke-width': r2(w),
      'stroke-linecap': cap || 'round', 'stroke-linejoin': 'round',
      'stroke-dasharray': dash || null, opacity: op == null ? null : op
    }, g);
  }

  // 表に見える紐 1 本ぶん（質感つき）
  function laceStroke(g, d, ctx, cap) {
    var s = ctx.s, p = ctx.pal;
    strokePath(g, d, p.base, laceWidth(ctx), cap || 'round');
    strokePath(g, d, p.hi, 1.6 * s, 'round', r2(1.4 * s) + ' ' + r2(2.4 * s));
  }

  // 靴の裏側を通る紐（同じ紐を薄く描く＝透け。友哉くん 2026-10-08 決定。点線は寸法線に見えて紐だと伝わりにくい）
  function backStroke(g, d, ctx) {
    laceStroke(el('g', { opacity: 0.3 }, g), d, ctx);
  }

  function lineD(a, b) { return 'M' + r2(a[0]) + ',' + r2(a[1]) + ' L' + r2(b[0]) + ',' + r2(b[1]); }

  // ---------- 通し方 → 線分 ----------
  // pos(i, 'L'|'R') が穴の中心。layer: top=表の横バー / under / over=交差の上 / back=裏側
  function segmentsFor(pattern, N) {
    var segs = [];
    function add(r1, s1, r2_, s2, layer) { segs.push({ a: [r1, s1], b: [r2_, s2], layer: layer }); }
    var i;
    if (pattern === 'single') {
      for (i = 1; i < N; i++) add(i, 'L', i, 'R', 'top');
      for (i = 1; i < N; i++) add(i + 1, 'R', i, 'L', 'back');
      add(N, 'L', 1, 'R', 'back');
    } else if (pattern === 'parallel') {
      add(1, 'L', 1, 'R', 'top');
      [parallelThread('L', N), parallelThread('R', N)].forEach(function (pts) {
        for (var k = 1; k < pts.length; k++) {
          var a = pts[k - 1], b = pts[k];
          add(a.r, a.s, b.r, b.s, a.r === b.r ? 'top' : 'back');
        }
      });
    } else { // overlap
      add(1, 'L', 1, 'R', 'top');
      for (i = 1; i < N; i++) {
        add(i, 'R', i + 1, 'L', 'under');
        add(i, 'L', i + 1, 'R', 'over');
      }
    }
    return segs;
  }

  // パラレルの 2 本の通り道（shoelace-calculator.js の計算 calcParallel と同じ経路）
  function parallelThread(side, N) {
    var pts, row, n2;
    if (side === 'L') {
      pts = [{ s: 'L', r: 1 }]; row = 1;
      while (row < N) {
        n2 = row + 2;
        if (n2 <= N) { pts.push({ s: 'R', r: n2 }); row = n2; if (row < N) pts.push({ s: 'L', r: row }); }
        else { if (row + 1 <= N) pts.push({ s: 'R', r: row + 1 }); break; }
      }
    } else {
      pts = [{ s: 'R', r: 1 }];
      if (N < 2) return pts;
      row = 2; pts.push({ s: 'L', r: row });
      while (row < N) {
        pts.push({ s: 'R', r: row });
        n2 = row + 2;
        if (n2 <= N) { row = n2; pts.push({ s: 'L', r: row }); }
        else { if (row + 1 <= N) pts.push({ s: 'L', r: row + 1 }); break; }
      }
    }
    return pts;
  }

  // ---------- 紐と穴を描く ----------
  // o: { N, pattern, pos(i,side), holeR, tail:{drop,out}|null, rows:[表示する段] }
  function drawLacing(ctx, o) {
    var g = el('g', { 'class': 'sla-lacing' }, ctx.svg);
    var segs = segmentsFor(o.pattern, o.N);
    var P = function (e) { return o.pos(e[0], e[1]); };
    var s = ctx.s, holeR = o.holeR;

    // 穴ごとのつながり数（1 なら紐の端がそこから出る）
    var deg = {};
    segs.forEach(function (sg) {
      [sg.a, sg.b].forEach(function (e) { var k = e[1] + e[0]; deg[k] = (deg[k] || 0) + 1; });
    });

    segs.filter(function (sg) { return sg.layer === 'back'; }).forEach(function (sg) {
      backStroke(g, lineD(P(sg.a), P(sg.b)), ctx);
    });

    if (o.tail) {
      for (var i = 1; i <= o.N; i++) {
        ['L', 'R'].forEach(function (side) {
          if (deg[side + i] === 1) drawTail(g, ctx, o.pos(i, side), side, o.tail);
        });
      }
    }

    segs.filter(function (sg) { return sg.layer === 'under'; }).forEach(function (sg) {
      laceStroke(g, lineD(P(sg.a), P(sg.b)), ctx);
    });

    var over = segs.filter(function (sg) { return sg.layer === 'over'; });
    over.forEach(function (sg) {
      // 交差の余白（穴の手前で止めて、穴の枠を消さない）
      var a = P(sg.a), b = P(sg.b);
      var dx = b[0] - a[0], dy = b[1] - a[1], len = Math.sqrt(dx * dx + dy * dy);
      var cut = holeR + 3 * s;
      if (len <= cut * 2) return;
      var ux = dx / len, uy = dy / len;
      el('line', {
        x1: r2(a[0] + ux * cut), y1: r2(a[1] + uy * cut), x2: r2(b[0] - ux * cut), y2: r2(b[1] - uy * cut),
        stroke: ctx.bg, 'stroke-width': r2(laceWidth(ctx) + 4.6 * s), 'stroke-linecap': 'butt'
      }, g);
    });
    if (over.length) {
      var og = el('g', { filter: 'url(#' + ctx.id + 'lift)' }, g);
      over.forEach(function (sg) { laceStroke(og, lineD(P(sg.a), P(sg.b)), ctx); });
    }

    segs.filter(function (sg) { return sg.layer === 'top'; }).forEach(function (sg) {
      laceStroke(g, lineD(P(sg.a), P(sg.b)), ctx);
    });

    for (var j = 1; j <= o.N; j++) {
      if (o.rows && o.rows.indexOf(j) < 0) continue;
      ['L', 'R'].forEach(function (side) {
        var p = o.pos(j, side);
        el('circle', { cx: r2(p[0]), cy: r2(p[1]), r: r2(holeR), fill: 'none',
          stroke: C.hole, 'stroke-width': r2(1.3 * Math.max(s, 0.75)) }, g);
      });
    }
    return g;
  }

  // 紐の端（穴の中心から外へ垂れて、先端に金属セル）。戻り値は先端の座標
  function drawTail(g, ctx, p, side, t) {
    var s = ctx.s, dir = side === 'L' ? -1 : 1;
    var x = p[0], y = p[1], ox = x + dir * t.out;
    var agH = 19 * s, agW = 6.4 * s;
    var yEnd = y + t.drop - agH;
    var d = 'M' + r2(x) + ',' + r2(y) +
      ' C' + r2(x) + ',' + r2(y + 0.18 * t.drop) + ' ' + r2(ox) + ',' + r2(y + 0.15 * t.drop) +
      ' ' + r2(ox) + ',' + r2(y + 0.42 * t.drop) + ' L' + r2(ox) + ',' + r2(yEnd + 1);
    laceStroke(g, d, ctx);
    el('rect', { x: r2(ox - agW / 2), y: r2(yEnd), width: r2(agW), height: r2(agH), rx: r2(1.4 * s),
      fill: 'url(#' + ctx.id + 'ag)' }, g);
    return [ox, y + t.drop];
  }

  // ---------- 強調・寸法線 ----------
  function goldRing(g, p, holeR, s) {
    el('circle', { cx: r2(p[0]), cy: r2(p[1]), r: r2(holeR + 6.4 * s), fill: 'none', stroke: C.gold, 'stroke-width': r2(1.2 * s) }, g);
  }
  function goldDot(g, p, s, bg) {
    el('circle', { cx: r2(p[0]), cy: r2(p[1]), r: r2(2.1 * s), fill: C.gold, stroke: bg, 'stroke-width': r2(0.8 * s) }, g);
  }
  function dimV(g, x, y1, y2, s) {
    el('line', { x1: x, y1: r2(y1), x2: x, y2: r2(y2), stroke: C.gold, 'stroke-width': r2(1 * s) }, g);
    [y1, y2].forEach(function (y) {
      el('line', { x1: r2(x - 6 * s), y1: r2(y), x2: r2(x + 6 * s), y2: r2(y), stroke: C.gold, 'stroke-width': r2(1 * s) }, g);
    });
  }
  function dimH(g, y, x1, x2, s) {
    el('line', { x1: r2(x1), y1: r2(y), x2: r2(x2), y2: r2(y), stroke: C.gold, 'stroke-width': r2(1 * s) }, g);
    [x1, x2].forEach(function (x) {
      el('line', { x1: r2(x), y1: r2(y - 6 * s), x2: r2(x), y2: r2(y + 6 * s), stroke: C.gold, 'stroke-width': r2(1 * s) }, g);
    });
  }
  function ext(g, x1, y1, x2, y2, s) {
    el('line', { x1: r2(x1), y1: r2(y1), x2: r2(x2), y2: r2(y2), stroke: C.gold, 'stroke-width': r2(0.8 * s), 'stroke-dasharray': r2(2 * s) + ' ' + r2(2 * s) }, g);
  }

  // 拡大窓「穴の中を通る紐から測る」: 図の右上に、基準の穴まわりを円で切り抜いて拡大
  function zoomWindow(ctx, lacingG, hole, cx, cy, R, k) {
    var g = el('g', { 'class': 'sla-zoom' }, ctx.svg);
    var clipId = ctx.id + 'zc';
    var cp = el('clipPath', { id: clipId }, ctx.defs);
    el('circle', { cx: cx, cy: cy, r: R }, cp);
    el('circle', { cx: cx, cy: cy, r: R, fill: ctx.bg }, g);
    var clipped = el('g', { 'clip-path': 'url(#' + clipId + ')' }, g);
    var inner = el('g', { transform: 'translate(' + cx + ' ' + cy + ') scale(' + k + ') translate(' + r2(-hole[0]) + ' ' + r2(-hole[1]) + ')' }, clipped);
    inner.appendChild(lacingG.cloneNode(true));
    goldDot(inner, hole, ctx.s, ctx.bg);
    ext(inner, hole[0] - R / k, hole[1], hole[0], hole[1], ctx.s * 0.75);
    el('circle', { cx: cx, cy: cy, r: R, fill: 'none', stroke: C.lineStrong, 'stroke-width': 1 }, g);
    txt(g, cx, cy + R + 14, '穴の中を通る', { size: 10 });
    txt(g, cx, cy + R + 27, '紐から測る', { size: 10 });
  }

  function mount(container, svg) { container.replaceChildren(svg); return svg; }

  var PATTERN_JA = { overlap: 'オーバーラップ', single: 'シングル', parallel: 'パラレル' };

  // ---------- 採寸ガイド（Step 1・3〜6）----------
  // o: { step, N, m, pattern }
  function guide(container, o) {
    var N = o.N, step = o.step, pattern = o.pattern || 'overlap';
    var W = 300, H = 380, xL = 100, xR = 200, yTop = 64, yBot = 280, holeR = 6.6, s = 1;
    var ctx = makeCtx('0 0 ' + W + ' ' + H, PATTERN_JA[pattern] + '・穴 ' + N + ' 対の図', s);
    var svg = ctx.svg;
    function y(i) { return N > 1 ? yTop + (i - 1) * (yBot - yTop) / (N - 1) : yTop; }
    function pos(i, side) { return [side === 'L' ? xL : xR, y(i)]; }

    txt(svg, 150, 22, 'つま先側', { fill: step === 4 ? C.ink : C.text });
    txt(svg, 150, H - 6, 'かかと側', { fill: step === 5 ? C.ink : C.text });

    var lg = drawLacing(ctx, { N: N, pattern: pattern, pos: pos, holeR: holeR, tail: { drop: 64, out: 16 } });
    var hg = el('g', { 'class': 'sla-marks' }, svg);

    if (step === 1) {
      for (var i = 1; i <= N; i++) {
        var hl = (i === 1 || i === N);
        txt(hg, xL - 24, y(i) + 4, String(i), { num: true, size: 12, fill: hl ? C.ink : C.muted });
        if (hl) { goldRing(hg, pos(i, 'L'), holeR, s); goldRing(hg, pos(i, 'R'), holeR, s); }
      }
    } else if (step === 3) {
      var top = pos(1, 'L'), bot = pos(N, 'L');
      goldRing(hg, top, holeR, s); goldRing(hg, bot, holeR, s);
      goldDot(hg, top, s, ctx.bg); goldDot(hg, bot, s, ctx.bg);
      dimV(hg, 44, top[1], bot[1], s);
      ext(hg, 50, top[1], top[0], top[1], s); ext(hg, 50, bot[1], bot[0], bot[1], s);
      zoomWindow(ctx, lg, top, 262, 62, 30, 2.4);
    } else if (step === 4 || step === 5) {
      var row = step === 4 ? 1 : N;
      var a = pos(row, 'L'), b = pos(row, 'R');
      var dy = step === 4 ? 36 : y(N) + 34;
      goldRing(hg, a, holeR, s); goldRing(hg, b, holeR, s);
      goldDot(hg, a, s, ctx.bg); goldDot(hg, b, s, ctx.bg);
      ext(hg, a[0], dy, a[0], a[1], s); ext(hg, b[0], dy, b[0], b[1], s);
      dimH(hg, dy, a[0], b[0], s);
      zoomWindow(ctx, lg, a, 262, 62, 30, 2.4);
    } else if (step === 6) {
      var m = o.m;
      if (m > 1 && m < N) {
        var ma = pos(m, 'L'), mb = pos(m, 'R');
        // 紐の上に重ねるので、下に地色の帯を敷いて読みやすくする（帯は穴の枠の手前で止め、枠を消さない）
        el('line', { x1: r2(ma[0] + holeR + 1.5), y1: r2(ma[1]), x2: r2(mb[0] - holeR - 1.5), y2: r2(mb[1]), stroke: ctx.bg, 'stroke-width': 3.5 }, hg);
        dimH(hg, ma[1], ma[0], mb[0], s);
        goldRing(hg, ma, holeR, s); goldRing(hg, mb, holeR, s);
        goldDot(hg, ma, s, ctx.bg); goldDot(hg, mb, s, ctx.bg);
        txt(hg, xL - 24, ma[1] + 4, String(m), { num: true, size: 12, fill: C.ink });
        zoomWindow(ctx, lg, ma, 262, 62, 30, 2.4);
      }
    }
    return mount(container, svg);
  }

  // ---------- Step 2: 通し方ボタンの小さな図 ----------
  function patternIcon(container, pattern) {
    var N = 4, s = 0.5, holeR = 3.6;
    var ctx = makeCtx('0 0 80 100', PATTERN_JA[pattern] + 'の図', s);
    function pos(i, side) { return [side === 'L' ? 20 : 60, 15 + (i - 1) * 20]; }
    drawLacing(ctx, { N: N, pattern: pattern, pos: pos, holeR: holeR, tail: { drop: 21, out: 5 } });
    return mount(container, ctx.svg);
  }

  // ---------- Step 7: 紐の余り ----------
  function remainder(container, o) {
    var pattern = (o && o.pattern) || 'overlap', s = 1, holeR = 6.6;
    var ctx = makeCtx('0 0 300 290', '紐の余りの図', s);
    var svg = ctx.svg;
    // 一番下の 2 段だけを見せる（3 段ぶん描いて 1 段目は図の外に出す）
    var ys = [0, -34, 40, 96];
    function pos(i, side) { return [side === 'L' ? 100 : 200, ys[i]]; }
    var lg = drawLacing(ctx, { N: 3, pattern: pattern, pos: pos, holeR: holeR, tail: null, rows: [2, 3] });
    var tips = {};
    ['L', 'R'].forEach(function (side) { tips[side] = drawTail(lg, ctx, pos(3, side), side, { drop: 158, out: 22 }); });
    // 穴の枠を紐の端の上にもう一度重ねる（端が穴の中心から出ていることを見せる）
    ['L', 'R'].forEach(function (side) {
      var p = pos(3, side);
      el('circle', { cx: p[0], cy: p[1], r: holeR, fill: 'none', stroke: C.hole, 'stroke-width': 1.3 }, lg);
    });
    var hg = el('g', { 'class': 'sla-marks' }, svg);
    [['L', 40, '左の余り'], ['R', 260, '右の余り']].forEach(function (d) {
      var p = pos(3, d[0]), tip = tips[d[0]];
      goldDot(hg, p, s, ctx.bg);
      dimV(hg, d[1], p[1], tip[1], s);
      ext(hg, d[1], p[1], p[0], p[1], s);
      ext(hg, d[1], tip[1], tip[0], tip[1], s);
      txt(hg, d[1], tip[1] + 24, d[2], { size: 12 });
    });
    // 上にも穴が続くことを示す点
    [100, 200].forEach(function (x) {
      el('circle', { cx: x, cy: 8, r: 1.6, fill: C.lineStrong }, hg);
      el('circle', { cx: x, cy: 16, r: 1.6, fill: C.lineStrong }, hg);
    });
    return mount(container, svg);
  }

  // ---------- 結果図（入力した横幅に合わせた形）----------
  // o: { pattern, W(1 始まり), N, m, isFallback }
  function result(container, o) {
    var N = o.N, Wd = o.W, s = 0.75, holeR = 5;
    var VW = 240, padX = 46, yTop = 36, ih = 180, yBot = yTop + ih;
    var ctx = makeCtx('0 0 ' + VW + ' 280', PATTERN_JA[o.pattern] + '・穴 ' + N + ' 対の結果図', s);
    var svg = ctx.svg;
    var maxW = Math.max.apply(null, Wd.slice(1, N + 1));
    var iw = VW - 2 * padX;
    function x(i, side) {
      var half = (iw / 2) * (Wd[i] / maxW);
      return side === 'L' ? VW / 2 - half : VW / 2 + half;
    }
    function y(i) { return yTop + ((i - 1) / (N - 1)) * ih; }
    function pos(i, side) { return [x(i, side), y(i)]; }

    drawLacing(ctx, { N: N, pattern: o.pattern, pos: pos, holeR: holeR, tail: { drop: 50, out: 12 } });

    var hg = el('g', { 'class': 'sla-marks' }, svg);
    if (!o.isFallback && o.m > 1 && o.m < N) {
      goldRing(hg, pos(o.m, 'L'), holeR, s); goldRing(hg, pos(o.m, 'R'), holeR, s);
    }
    function arrowH(yy, x1, x2) {
      el('line', { x1: r2(x1), y1: yy, x2: r2(x2), y2: yy, stroke: C.muted, 'stroke-width': 0.8 }, hg);
      [x1, x2].forEach(function (xx) { el('line', { x1: r2(xx), y1: yy - 4, x2: r2(xx), y2: yy + 4, stroke: C.muted, 'stroke-width': 0.8 }, hg); });
    }
    arrowH(y(1) - 14, x(1, 'L'), x(1, 'R'));
    txt(hg, VW / 2, y(1) - 20, 'つま先側', { size: 9, fill: C.muted });
    arrowH(y(N) + 14, x(N, 'L'), x(N, 'R'));
    txt(hg, VW / 2, y(N) + 28, 'かかと側', { size: 9, fill: C.muted });
    var xr = 0;
    for (var i = 1; i <= N; i++) xr = Math.max(xr, x(i, 'R'));
    xr += 18;
    el('line', { x1: r2(xr), y1: r2(y(1)), x2: r2(xr), y2: r2(y(N)), stroke: C.muted, 'stroke-width': 0.8 }, hg);
    [y(1), y(N)].forEach(function (yy) { el('line', { x1: r2(xr - 4), y1: r2(yy), x2: r2(xr + 4), y2: r2(yy), stroke: C.muted, 'stroke-width': 0.8 }, hg); });
    txt(hg, xr + 9, (y(1) + y(N)) / 2 + 3, 'Z', { size: 10, fill: C.muted, num: true, anchor: 'start' });
    return mount(container, svg);
  }

  window.ShoelaceLaceArt = {
    guide: guide,
    patternIcon: patternIcon,
    remainder: remainder,
    result: result,
    _segmentsFor: segmentsFor
  };
})();
